// Rashi name translations
export const RASHI_TRANSLATIONS: Record<string, Record<string, string>> = {
    'English': {
        'Aries': 'Aries', 'Taurus': 'Taurus', 'Gemini': 'Gemini', 'Cancer': 'Cancer',
        'Leo': 'Leo', 'Virgo': 'Virgo', 'Libra': 'Libra', 'Scorpio': 'Scorpio',
        'Sagittarius': 'Sagittarius', 'Capricorn': 'Capricorn', 'Aquarius': 'Aquarius', 'Pisces': 'Pisces',
        'मेष': 'Aries', 'वृषभ': 'Taurus', 'मिथुन': 'Gemini', 'कर्क': 'Cancer',
        'सिंह': 'Leo', 'कन्या': 'Virgo', 'तुला': 'Libra', 'वृश्चिक': 'Scorpio',
        'धनु': 'Sagittarius', 'मकर': 'Capricorn', 'कुंभ': 'Aquarius', 'मीन': 'Pisces'
    },
    'Hindi': {
        'Aries': 'मेष', 'Taurus': 'वृषभ', 'Gemini': 'मिथुन', 'Cancer': 'कर्क',
        'Leo': 'सिंह', 'Virgo': 'कन्या', 'Libra': 'तुला', 'Scorpio': 'वृश्चिक',
        'Sagittarius': 'धनु', 'Capricorn': 'मकर', 'Aquarius': 'कुंभ', 'Pisces': 'मीन',
        'मेष': 'मेष', 'वृषभ': 'वृषभ', 'मिथुन': 'मिथुन', 'कर्क': 'कर्क',
        'सिंह': 'सिंह', 'कन्या': 'कन्या', 'तुला': 'तुला', 'वृश्चिक': 'वृश्चिक',
        'धनु': 'धनु', 'मकर': 'मकर', 'कुंभ': 'कुंभ', 'मीन': 'मीन'
    }
};

export const translateRashi = (rashi: string | undefined, language: 'english' | 'hindi'): string => {
    if (!rashi) return '';
    const langKey = language === 'hindi' ? 'Hindi' : 'English';
    return RASHI_TRANSLATIONS[langKey][rashi] || rashi;
};

export const FREE_COMPATIBILITY_TRANSLATIONS: Record<string, any> = {
    'English': {
        // Page Header
        title: "Kundli Matching",
        description: "Get detailed Guna Milan compatibility analysis for you and your partner. Vedic astrology compatibility based on 36 Gunas.",

        // Form Labels
        person1: "Person 1 (Groom)",
        person2: "Person 2 (Bride)",
        fullName: "Full Name",
        fullNamePlaceholder: "Enter name",
        gender: "Gender",
        male: "Male",
        female: "Female",
        dateOfBirth: "Date of Birth",
        timeOfBirth: "Time of Birth",
        birthLocation: "Birth Location",
        searchCity: "Search city...",

        // Buttons
        checkCompatibility: "Check Compatibility",
        analyzing: "Analyzing...",
        newAnalysis: "New Analysis",

        // Kundli Selector
        selectSaved: "Select Saved Kundli",
        searchCharts: "Search...",
        cloudSaved: "Cloud Saved",
        savedLocally: "Saved Locally",
        noSavedKundlis: "No saved kundlis",
        orEnterManually: "or enter manually below",
        selected: "Selected",
        clear: "Clear",

        // Results - Overall Score
        gunaScore: "Guna Score",
        outOf: "out of",
        compatibility: "Compatibility",
        excellent: "Excellent",
        good: "Good",
        average: "Average",
        belowAverage: "Below Average",
        low: "Low",

        // Compatibility Descriptions for Share Card
        excellentDesc: "A highly auspicious match! Strong harmony in all aspects of life.",
        goodDesc: "A favorable match with good compatibility and mutual understanding.",
        averageDesc: "A moderate match. Some adjustments may be needed for harmony.",
        belowAverageDesc: "Challenges may arise. Remedies and understanding are recommended.",
        lowDesc: "Significant differences exist. Seek guidance from an astrologer.",

        // Koota Analysis
        kootaAnalysis: "Ashta Koota Analysis",
        points: "Points",

        // Koota Names
        varnaName: "Varna",
        vashyaName: "Vashya",
        taraName: "Tara",
        yoniName: "Yoni",
        grahaMaitriName: "Graha Maitri",
        ganaName: "Gana",
        bhakootName: "Bhakoot",
        nadiName: "Nadi",

        // Koota Descriptions
        varnaDesc: "Spiritual compatibility and ego levels",
        vashyaDesc: "Mutual attraction and dominance",
        taraDesc: "Destiny and luck compatibility",
        yoniDesc: "Physical and sexual compatibility",
        grahaMaitriDesc: "Mental and intellectual compatibility",
        ganaDesc: "Temperament and behavior match",
        bhakootDesc: "Love, finance and health compatibility",
        nadiDesc: "Health and genes compatibility",

        // Detailed Koota Labels
        boyToGirl: "Boy → Girl",
        girlToBoy: "Girl → Boy",
        housePosition: "House",
        cancellation: "Cancelled",
        doshaPresent: "Dosha",
        nadiDosha: "Nadi Dosha",
        noDoshaFound: "No Dosha",

        // Birth Details
        birthDetails: "Birth Details",
        rashi: "Moon Sign",
        nakshatra: "Nakshatra",
        pada: "Pada",
        signLord: "Sign Lord",
        lagnaChart: "Lagna Chart",
        viewFullKundli: "View Full Kundli",

        // Summary Section
        compatibilitySummary: "Compatibility Summary",
        strengths: "Strengths",
        areasOfConcern: "Areas of Concern",

        // CTA Section
        wantGuidance: "Want Detailed Guidance?",
        guidanceDesc: "Get personalized compatibility insights and relationship advice from our AI astrologer.",
        chatWithAI: "Chat with AI",

        // Validation Messages
        fillPerson1: "Please fill in all required fields for Person 1",
        fillPerson2: "Please fill in all required fields for Person 2",
        invalidDate: "Invalid date format",
        analysisGenerated: "Compatibility analysis generated!",
        analysisFailed: "Failed to generate compatibility analysis. Please try again.",

        // Share
        share: "Share",
        download: "Save",
        copy: "Copy",
        copied: "Copied",
        shareTitle: "Kundli Matching Result",
        shareDescription: "Check your compatibility with Vedic astrology",
        copiedToClipboard: "Image copied to clipboard!",
        downloadComplete: "Image downloaded!",
        shareError: "Unable to share. Try downloading instead.",
        poweredBy: "Powered by BhriguGPT"
    },
    'Hindi': {
        // Page Header
        title: "कुंडली मिलान",
        description: "अपनी और अपने साथी की जन्म कुंडली का विस्तृत गुण मिलान प्राप्त करें। 36 गुणों पर आधारित वैदिक ज्योतिष अनुकूलता विश्लेषण।",

        // Form Labels
        person1: "व्यक्ति 1 (वर)",
        person2: "व्यक्ति 2 (वधू)",
        fullName: "पूरा नाम",
        fullNamePlaceholder: "नाम दर्ज करें",
        gender: "लिंग",
        male: "पुरुष",
        female: "महिला",
        dateOfBirth: "जन्म तिथि",
        timeOfBirth: "जन्म समय",
        birthLocation: "जन्म स्थान",
        searchCity: "शहर खोजें...",

        // Buttons
        checkCompatibility: "अनुकूलता जांचें",
        analyzing: "विश्लेषण हो रहा है...",
        newAnalysis: "नया विश्लेषण",

        // Kundli Selector
        selectSaved: "सहेजी गई कुंडली चुनें",
        searchCharts: "खोजें...",
        cloudSaved: "क्लाउड में सहेजा गया",
        savedLocally: "स्थानीय रूप से सहेजा गया",
        noSavedKundlis: "कोई सहेजी गई कुंडली नहीं",
        orEnterManually: "या नीचे मैन्युअल रूप से दर्ज करें",
        selected: "चयनित",
        clear: "हटाएं",

        // Results - Overall Score
        gunaScore: "गुण स्कोर",
        outOf: "में से",
        compatibility: "अनुकूलता",
        excellent: "उत्कृष्ट",
        good: "अच्छा",
        average: "औसत",
        belowAverage: "औसत से कम",
        low: "कम",

        // Compatibility Descriptions for Share Card
        excellentDesc: "अत्यंत शुभ मिलान! जीवन के सभी पहलुओं में मजबूत सामंजस्य।",
        goodDesc: "अच्छी अनुकूलता और आपसी समझ के साथ अनुकूल मिलान।",
        averageDesc: "मध्यम मिलान। सामंजस्य के लिए कुछ समायोजन आवश्यक हो सकते हैं।",
        belowAverageDesc: "चुनौतियां आ सकती हैं। उपाय और समझ की सिफारिश की जाती है।",
        lowDesc: "महत्वपूर्ण अंतर मौजूद हैं। ज्योतिषी से मार्गदर्शन लें।",

        // Koota Analysis
        kootaAnalysis: "अष्टकूट विश्लेषण",
        points: "अंक",

        // Koota Names
        varnaName: "वर्ण",
        vashyaName: "वश्य",
        taraName: "तारा",
        yoniName: "योनि",
        grahaMaitriName: "ग्रह मैत्री",
        ganaName: "गण",
        bhakootName: "भकूट",
        nadiName: "नाड़ी",

        // Koota Descriptions
        varnaDesc: "आध्यात्मिक अनुकूलता और अहंकार स्तर",
        vashyaDesc: "आपसी आकर्षण और प्रभुत्व",
        taraDesc: "भाग्य और किस्मत अनुकूलता",
        yoniDesc: "शारीरिक और यौन अनुकूलता",
        grahaMaitriDesc: "मानसिक और बौद्धिक अनुकूलता",
        ganaDesc: "स्वभाव और व्यवहार मिलान",
        bhakootDesc: "प्रेम, वित्त और स्वास्थ्य अनुकूलता",
        nadiDesc: "स्वास्थ्य और जीन अनुकूलता",

        // Detailed Koota Labels
        boyToGirl: "वर → वधू",
        girlToBoy: "वधू → वर",
        housePosition: "भाव",
        cancellation: "निरस्त",
        doshaPresent: "दोष",
        nadiDosha: "नाड़ी दोष",
        noDoshaFound: "कोई दोष नहीं",

        // Birth Details
        birthDetails: "जन्म विवरण",
        rashi: "चंद्र राशि",
        nakshatra: "नक्षत्र",
        pada: "पद",
        signLord: "राशि स्वामी",
        lagnaChart: "लग्न कुंडली",
        viewFullKundli: "पूर्ण कुंडली देखें",

        // Summary Section
        compatibilitySummary: "अनुकूलता सारांश",
        strengths: "शक्तियां",
        areasOfConcern: "चिंता के क्षेत्र",

        // CTA Section
        wantGuidance: "क्या आप विस्तृत मार्गदर्शन चाहते हैं?",
        guidanceDesc: "हमारे AI ज्योतिषी से व्यक्तिगत अनुकूलता अंतर्दृष्टि और संबंध सलाह प्राप्त करें।",
        chatWithAI: "AI से बात करें",

        // Validation Messages
        fillPerson1: "कृपया व्यक्ति 1 के लिए सभी आवश्यक फ़ील्ड भरें",
        fillPerson2: "कृपया व्यक्ति 2 के लिए सभी आवश्यक फ़ील्ड भरें",
        invalidDate: "अमान्य तिथि प्रारूप",
        analysisGenerated: "अनुकूलता विश्लेषण उत्पन्न हुआ!",
        analysisFailed: "अनुकूलता विश्लेषण उत्पन्न करने में विफल। कृपया पुनः प्रयास करें।",

        // Share
        share: "शेयर करें",
        download: "सेव करें",
        copy: "कॉपी",
        copied: "कॉपी हो गया",
        shareTitle: "कुंडली मिलान परिणाम",
        shareDescription: "वैदिक ज्योतिष से अपनी अनुकूलता जांचें",
        copiedToClipboard: "छवि क्लिपबोर्ड पर कॉपी हो गई!",
        downloadComplete: "छवि डाउनलोड हो गई!",
        shareError: "शेयर करने में असमर्थ। डाउनलोड करके देखें।",
        poweredBy: "BhriguGPT द्वारा संचालित"
    }
};
